<script>
import 'components/modals/ModalAPI';

export default {
    name: 'ModalAPIEx'
};
</script>
